<template>
  <div class="main-content-container overflow-hidden">
    <PageTitle pageTitle="Partidos"   />

    <Matches />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import PageTitle from "@/components/Common/PageTitle.vue";
import Matches from "@/components/Pages/Admin/Matches/index.vue";

export default defineComponent({
  name: "MatchesPage",
  components: {
    PageTitle,
    Matches,
  },
});
</script>
